import React from "react";

const DEFAULT_OPTIONS = [5, 10, 20, 30, 50, 100];

const RecordsPerPage = ({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
  label = "Records per page :",
  wrapperClassName = "d-flex align-items-center justify-content-start mx-3",
  labelClassName,
  selectClassName = "select3",
  labelStyle,
  selectStyle,
  id = "perpage",
  useDefaultStyles = true,
}) => {
  const baseLabelStyle = useDefaultStyles
    ? {
        fontSize: "13px",
        fontWeight: "500",
        color: "#172B4D",
      }
    : {};
  const baseSelectStyle = useDefaultStyles
    ? {
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "18.9px",
        color: "#172B4D",
        width: "56px",
        height: "24px",
        borderRadius: "10px",
        border: "0.7px solid #E5E5E5",
        padding: "0 4px",
        backgroundColor: "#FFFFFF",
      }
    : {};
  return (
    <div className={wrapperClassName}>
      <span
        className={labelClassName}
        style={{
          ...baseLabelStyle,
          ...labelStyle,
        }}
      >
        {label}
      </span>
      <select
        className={selectClassName}
        id={id}
        value={value}
        onChange={onChange}
        style={{
          ...baseSelectStyle,
          ...selectStyle,
        }}
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};

export default RecordsPerPage;
